module.exports = __webpack_public_path__ + "files/56e3b5460fe62edf71a95733aa4f1b51.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/droidserif-bolditalic-webfont.woff
 ** module id = 902
 ** module chunks = 0
 **/